import { render, staticRenderFns } from "./directionalPolicy.vue?vue&type=template&id=331dd747&scoped=true&"
import script from "./directionalPolicy.vue?vue&type=script&lang=js&"
export * from "./directionalPolicy.vue?vue&type=script&lang=js&"
import style0 from "./directionalPolicy.vue?vue&type=style&index=0&id=331dd747&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331dd747",
  null
  
)

export default component.exports